/** Millisecondes restantes avant une date ISO (0 si passée). */
export function msUntilIso(iso, nowMs = Date.now()) {
  const end = iso ? Date.parse(String(iso)) : NaN;
  if (!Number.isFinite(end)) return null;
  return Math.max(0, end - nowMs);
}

function pad2(n) {
  return String(n).padStart(2, "0");
}

/** Décompte lisible avec secondes : `2 j 05:32:18` ou `71:45:09`. */
export function formatCountdownLive(ms) {
  const totalSec = Math.max(0, Math.floor(Number(ms) / 1000));
  const d = Math.floor(totalSec / 86400);
  const h = Math.floor((totalSec % 86400) / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  if (d > 0) return `${d} j ${pad2(h)}:${pad2(m)}:${pad2(s)}`;
  return `${pad2(h)}:${pad2(m)}:${pad2(s)}`;
}
